export const UPDATE_SOURCE = 'UPDATE_SOURCE'
export const SET_SOURCE_FILE_ID = 'SET_SOURCE_FILE_ID'

export const SET_AUTORECONCILIATION_FIELDS = 'SET_AUTORECONCILIATION_FIELDS'
export const SET_COLLECTIONS = 'SET_COLLECTIONS'
export const UPDATE_SELECTED_COLLECTION = 'UPDATE_SELECTED_COLLECTION'
export const SET_RECONCILIATION_FIELDS_FOR_SOURCE =
  'SET_RECONCILIATION_FIELDS_FOR_SOURCE'

export const SET_RECONCILIATION_FIELDS = 'SET_RECONCILIATION_FIELDS'
export const UPDATE_RECONCILIATION_FIELD_SELECTION =
  'UPDATE_RECONCILIATION_FIELD_SELECTION'
export const UPDATE_RECONCILIATION_FIELD_ACCOUNTS =
  'UPDATE_RECONCILIATION_FIELD_ACCOUNTS'

export const SET_SOURCE_FIELDS = 'SET_SOURCE_FIELDS'

export const UPDATE_FIELDS_LOADING = 'UPDATE_FIELDS_LOADING'
export const UPDATE_FIELDS_LOADED = 'UPDATE_FIELDS_LOADED'
